import {writable} from "svelte/store";

export const documentos = writable([]);
export const cuenta = writable({usuario:"",pass:"",nombre:"",vence:""});
